
















































































































import { CatalogueItemModel, CatalogueItemTypeEnum, UnitOfMeasureModel, WorkTaskRuleModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Guid } from '@/libs/common/functions/guid';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { catalogueItemsStore } from '@/libs/catalogue-items/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import UnitOfMeasureSelect from '@/libs/common/components-smart/UnitOfMeasureSelect.vue';
import { workTaskRulesStore } from '@/libs/work-task-rules/+state/store';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import {Constants} from "@/constants";

@Component({})
export default class CatalogItemDialog extends Page {

    dialog = false;
    valid = true;
    saving = false;
    item: CatalogueItemModel | null = null;
    priceSuffix = "";
    deleteDialog = false;
    deleteDialogLoading = false;
    deleteDialogRulesExists = false;
    deleting = false;
    cannotDeactivateDialog = false;

    get isNewItem() : boolean {
        return this.item?.id == Guid.EmptyGuid();
    }

    @Watch("dialog")
    dialogChanged(v: boolean) {
        if (!v)
            this.close();
    }

    @Ref() form!: any;

    load(id: string | null) {
        if (id == null || id == Guid.EmptyGuid()) {
            this.item = {
                id: Guid.EmptyGuid(),
                catalogueItemType: CatalogueItemTypeEnum.Ordinary,
                type: "Charged",
                name: undefined,
                description: undefined,
                unitOfMeasureId: undefined,
                reportedUnitOfMeasureId: undefined,
                isActive: true
            } as CatalogueItemModel;
        }
        else {
            catalogueItemsStore.dispatch(CrudAction.Get, { id: id });
            this.subscribe(catalogueItemsStore, CrudReponse.Get).then((e: CatalogueItemModel) => {
                this.item = e;
            });
        }
    }

    open (id: string | null = null) {
        this.load(id);
        this.dialog = true;
    }

    close () {
        this.dialog = false;
    }

    save () {
        if (this.form.validate()) {
            this.saving = true;
            if (this.item!.id == Guid.EmptyGuid()) {
                catalogueItemsStore.dispatch(CrudAction.Create, { item: this.item });
                this.subscribe(catalogueItemsStore, CrudReponse.Create).then((e: CatalogueItemModel) => {
                    this.saving = false;
                    this.close();
                }).catch((e: any) => {
                    this.saving = false;
                });
            }
            else {
                workTaskRulesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskRuleModel>(undefined, [
                    { field: "catalogueItemId", op: "eq", comparand: this.item!.id! },
                    { field: "workTaskStateId", op: "eq", comparand: Constants.WorkTaskRuleActiveId }
                ], { pageIndex: 1, pageSize: 1 }, false, "WorkTaskRuleUpdateCheck"));
                this.subscribe(workTaskRulesStore, CrudReponse.GetAll, "WorkTaskRuleUpdateCheck").then((e: WorkTaskRuleModel[]) => {
                    let canContinue = true;
                    if (!this.item?.isActive && e.count() > 0) {
                        canContinue = false;
                        this.cannotDeactivateDialog = true;
                        this.saving = false;
                    }
                    if (canContinue) {
                        catalogueItemsStore.dispatch(CrudAction.Update, { item: this.item });
                        this.subscribe(catalogueItemsStore, CrudReponse.Update).then((e: CatalogueItemModel) => {
                            this.saving = false;
                            this.close();
                        }).catch((e: any) => {
                            this.saving = false;
                        });
                    }
                }).catch((e) => {
                    console.error(e);
                    this.saving = false;
                });
            }
        }
    }

    unitOfMeasureChanged (e: UnitOfMeasureModel) {
        this.item!.unitOfMeasure = e;
        this.priceSuffix = this.item == null || this.item.unitOfMeasure == null ? "" : ("Kč / " + this.item.unitOfMeasure.shortName);
    }

    reportedUnitOfMeasureChanged (e: UnitOfMeasureModel) {
        this.item!.reportedUnitOfMeasure = e;
    }

    deleteClick () {
        this.deleteDialogLoading = true;
        workTaskRulesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskRuleModel>(undefined, [
            { field: "catalogueItemId", op: "eq", comparand: this.item!.id! }
        ], { pageIndex: 1, pageSize: 1 }, false, "WorkTaskRuleDeleteCheck"));
        this.subscribe(workTaskRulesStore, CrudReponse.GetAll, "WorkTaskRuleDeleteCheck").then((e: WorkTaskRuleModel[]) => {
            this.deleteDialogLoading = false;
            if (e.length > 0) {
                this.deleteDialogRulesExists = true;
            }
            else {
                this.deleteDialog = true;
            }
        }).catch((e) => {
            console.error(e);
            this.deleteDialogLoading = false;
            this.deleteDialog = false;
        });
    }

    deleteItem () {
        this.deleting = true;
        catalogueItemsStore.dispatch(CrudAction.Delete, { id: this.item?.id });
        this.subscribe(catalogueItemsStore, CrudReponse.Delete).then((e: CatalogueItemModel) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.close();
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

}
